import './PasswordModal.scss';

import { Field } from "../common-components/Field/Field";
import { Button } from "../common-components/Buttons/Buttons";

import { usePasswordModal } from "../hooks/usePasswordModal";

const PasswordModal = () => {
    const { formId, handleChangePassword } = usePasswordModal();

    return (
        <div className={"password-modal"}>
            <div className={"password-modal_container"}>
                <div className={"password-modal_title"}>
                    {"Смена пароля"}
                </div>
                <form className={"password-modal_fields"}>
                    <Field
                        label={"Старый пароль"}
                        name={"old_password"}
                        formId={formId}
                        type={"password"}
                        validationRules={{required: true}}
                    />
                    <Field
                        label={"Новый пароль"}
                        name={"new_password"}
                        formId={formId}
                        type={"password"}
                        validationRules={{required: true}}
                    />
                    <Field
                        label={"Подвердите новый пароль"}
                        name={"new_password_confirmation"}
                        formId={formId}
                        type={"password"}
                        validationRules={{required: true}}
                    />
                </form>
                <div className={"password-modal_button"}>
                    <Button title={"Поменять пароль"} onClick={handleChangePassword}/>
                </div>
            </div>
        </div>
    )
}

export default PasswordModal;